module.exports = __webpack_public_path__ + "img/10.7c489b3d.png";